import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=127de34e&scoped=true&"
import script from "./submitDialog.vue?vue&type=script&lang=js&"
export * from "./submitDialog.vue?vue&type=script&lang=js&"
import style0 from "./submitDialog.vue?vue&type=style&index=0&id=127de34e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127de34e",
  null
  
)

export default component.exports